/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import DataTable from "react-data-table-component";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles } from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"

import { Typography } from "@mui/material";
import { RecentActors } from "@mui/icons-material";
import { FlexGrid, Card, Link } from '@albo-ui/core'

const ManualCheckList = (props) => {
  const [data, setData] = useState([]);
  const [active, setActive] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (props.update) {
      complianceInit(props.page);
      props.changeUpdate(0);
    }

    setData(JSON.parse(JSON.stringify(props.content)));
  }, [props.update]);

  const colapse = () => {
    if (!active) {
      setActive(true);
    } else {
      setActive(false);
    }
  };

  const complianceInit = async (page) => {
    props.changeLoader(true);

    let widgetsCompliance = await API.service(
      "complianceInit",
      page,
      props.pos,
      props.changeAlert,
      props.changeLoader,
      history
    );
    if (widgetsCompliance.status == 200 &&  widgetsCompliance.data.data.response == "OK" ) {
      setData(widgetsCompliance.data.data.widget[0].content);
    }
    props.changeLoader(false);
  };

  const changeSelected = async (uuid, index) => {
    props.changeLoader(true);
    await props.newWidgets("infoPersonalCompliance", uuid);
    props.changeLoader(false);
  };

  // ----------------------------------------------------------  
  const columns = [
    {
      cell: (item, index) => {
        return (
          <a href="#" data-tag="allowRowEvents" onClick={changeSelected.bind(this, item.uuid, index)}>
            <VisibilityIcon />
          </a>
        );
      },
      width: "10%", sortable: true,
    },
    { selector: (row) => row.name, name: "Nombre", width: "30%", sortable: true },
    { selector: (row) => row.email, name: "Email", width: "30%", sortable: true },
    { selector: (row) => row.statusParse, name: "Estatus", width: "15%", sortable: true },
    { selector: (row) => row.risk_level, name: "Nivel de riesgo", width: "15%", sortable: true },
  ];

  const paginationComponentOptions = {
    rangeSeparatorText: "de",
    noRowsPerPage: true,
  };

  return (
    <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: "white", marginBottom: 15}}> 
      <FlexGrid container fullWidth justify="space-between">
        <FlexGrid item>
          <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}} fontWeight={600}>
            <RecentActors sx={{ marginRight: 1 }}/>  Validación de identidad
          </Typography>
        </FlexGrid>
        <FlexGrid container justify="flex-end" alignItems='center' spacing={1}>
          <Link onClick={colapse} bold typography="smallTitle">
          {!active ? "Ver listado" : "Ocultar listado"}
          </Link>
        </FlexGrid> 
      </FlexGrid>
      {active &&
          <ThemeProvider theme={theme}>
            <DataTable
              columns={columns}
              data={data}
              customStyles={customStyles}
              pagination
              paginationServer
              paginationComponentOptions={paginationComponentOptions}
              paginationTotalRows={props.total}
              onChangePage={complianceInit}
              paginationPerPage={props.totalPage}
              noDataComponent={noDataComponent}
            />
          </ThemeProvider>
      }
    </Card>
  );
};

export default ManualCheckList;
